import { render, staticRenderFns } from "./list-shop-user.vue?vue&type=template&id=32b4ec72"
import script from "./list-shop-user.vue?vue&type=script&lang=js"
export * from "./list-shop-user.vue?vue&type=script&lang=js"
import style0 from "./list-shop-user.vue?vue&type=style&index=0&id=32b4ec72&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports